import { useEffect } from "react";

const useScrollIntoView = ({ elementId, trigger }) => {
  useEffect(() => {
    if (!trigger) return;
    document.getElementById(elementId)?.scrollIntoView();
  }, [trigger]);
};

export default useScrollIntoView;
